<template>
  <v-dialog
    persistent
    :value="value"
    @input="$emit('input', $event)"
    max-width="450"
  >
    <v-card>
      <v-card-title>
        {{ is2FAEnabled ? 'Disable' : 'Enable' }} Two Factor Authentication
      </v-card-title>
      <v-divider class="mb-2" />
      <v-card-text class="text-subtitle-1">
        {{
          is2FAEnabled
            ? 'You are about to disable two-factor authentication.'
            : 'You are about to enable two-factor authentication.'
        }}
        <br />
        <p>Please enter an OTP from your authenticator app to continue</p>

        <v-sheet class="mx-auto mt-6" max-width="400">
          <v-otp-input v-model="code" :length="6" />
        </v-sheet>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text @click="$emit('input', false)">Cancel</v-btn>
        <v-btn
          color="primary"
          :disabled="!code || code?.length < 6"
          @click="submit()"
          >Confirm</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import pageMixin from '@/mixins/page.mixin';
import { mapGetters } from 'vuex';
import { AppService } from '@/modules/shared/services/app.service';
export default {
  mixins: [pageMixin],
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      code: null
    };
  },
  watch: {
    value(val) {
      if (!val) {
        this.code = null;
      }
    }
  },
  computed: {
    ...mapGetters('authModule', ['user']),
    is2FAEnabled() {
      return this.user?.isTwoFactorAuthenticationEnabled;
    }
  },
  methods: {
    async submit() {
      if (!this.code || this.code.length < 6)
        return this.showSnack({
          timeout: 12000,
          color: 'error',
          title: 'Invalid Token',
          message: 'Please enter a valid token from your authenticator app'
        });

      try {
        const service = new AppService();
        const res = await service.toggle2fa({
          code: this.code,
          email: this.user.email
        });
        console.log(res.data);
        this.$store.commit('authModule/SET_USER', res.data);
        this.$store.commit('authModule/SET_TOKENS', res.data);
        this.showSnack({
          color: 'success',
          title: `2FA ${!this.is2FAEnabled ? 'disabled' : 'enabled'}`,
          message: `You have successfully ${
            !this.is2FAEnabled ? 'disabled' : 'enabled'
          } 2FA`
        });
        this.$emit('input', false);
      } catch (error) {
        this.showSnack({
          color: 'error',
          title: `Unable to ${this.is2FAEnabled ? 'disable' : 'enable'} 2FA`,
          message: `Please try again`
        });
      }
    }
  }
};
</script>
